const getupgradeInPlansDictionary = function (data) {
  const upgradeInPlansDictionary = {
    trademo_intel_in_pro: {
      name: "Pro Plan",
      key: "trademo_intel_in_pro",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "Unlimited searches per day",
        "120,000 shipment downloads per user annually",
        "1,000 employee level contact downloads per user annually",
        "Bookmark potential importer and exporter profiles",
      ],
    },
    trademo_intel_in_advanced: {
      name: "Advanced Plan",
      key: "trademo_intel_in_advanced",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "Last 24 months shipments data (updated daily)",
        "300,000 shipment downloads per user annually",
        "1000 employee level contact downloads per user annually",
        "Analytics & Insights on Search Results",
        "Bookmark potential importer and exporter profiles",
      ],
    },
    trademo_intel_in_enterprise: {
      name: "Enterprise Plan",
      key: "trademo_intel_in_enterprise",
      upgradeMessageArrivalDate: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageEmailAlert: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      upgradeMessageXlsDownload: "You do not have sufficient credits available to download XXX shipments.",
      upgradeMessageLiveNotification: "You have access to only historical data. To access recent India Shipments. ", // Need to change the content (Not In Use Right Now)
      dashboardUpgradeMessageEmailAlert: "",
      planFeatures: [
        "2020 - Latest Date",
        "Unlimited downloads with 10K downloads at a time per user",
        "1000 employee level contact downloads per user annually",
        "Analytics & Insights on Search Results",
        "Bookmark potential importer and exporter profiles",
      ],
    },
  };
  return upgradeInPlansDictionary;
};
exports.getupgradeInPlansDictionary = getupgradeInPlansDictionary;
